export default __webpack_public_path__ + "static/media/wN.72ce2510.svg";